import { type PaymentMethodType, payments } from '@/components/Wallet/Deposit/DepositBuyCryptoModal/data';
import { gunterzBold } from '@/theme/fonts';
import type { DIALOG } from '@/types';
import { useLingui } from '@lingui/react';
import { Box, Card, Group, Stack, Text, rem } from '@mantine/core';
import { useState } from 'react';
import { InfoAddPaymentButton } from './InfoAddPaymentButton';
import { InfoPaymentMethodItem } from './InfoPaymentMethodItem';
import { InfoAddPaymentModal } from './InfoPaymentViews/InfoAddPaymentModal';
import { InfoDeletePaymentModal } from './InfoPaymentViews/InfoDeletePaymentModal';
import { InfoEditPaymentModal } from './InfoPaymentViews/InfoEditPaymentModal';
export const InfoPaymentMethodCard: React.FC = () => {
  const {
    i18n
  } = useLingui();
  const [selected, setSelected] = useState<PaymentMethodType | null>(payments[0]);
  const [openDialog, setOpenDialog] = useState<DIALOG | null>(null);
  return <Card h="100%" radius={5} bg="var(--bg-400)" p={{
    base: 10,
    sm: 20
  }}>
      <Stack gap={24} py={12}>
        <Text c="var(--text-white)" className={gunterzBold.className} fz={{
        base: 14,
        sm: 18
      }} lh={{
        base: rem(14),
        sm: rem(18)
      }}>
          {i18n._('Payment methods')}
        </Text>

        <Box>
          {payments.length === 0 && <Text fz="xs" tt="uppercase" fw={700} c="var(--text-dark)">
              {i18n._('Add your first credit/debit card for payment')}
            </Text>}

          <Stack>
            {payments.map(item => <InfoPaymentMethodItem key={item.paymentName} value={item.paymentName} checked={selected?.paymentName === item.paymentName} handleClick={() => setSelected(item)} setOpenDialog={setOpenDialog} {...item} />)}
          </Stack>
          <Group justify={payments.length === 0 ? 'start' : 'end'}>
            <InfoAddPaymentButton setOpenDialog={setOpenDialog} />
          </Group>
        </Box>
      </Stack>
      <InfoAddPaymentModal openDialog={openDialog} setOpenDialog={setOpenDialog} />
      <InfoDeletePaymentModal openDialog={openDialog} setOpenDialog={setOpenDialog} />
      <InfoEditPaymentModal openDialog={openDialog} setOpenDialog={setOpenDialog} />
    </Card>;
};